// projectReducer.js

import { GET_ALL_EMP_TASKS_FAILURE, GET_ALL_EMP_TASKS_REQUEST, GET_ALL_EMP_TASKS_SUCCESS } from "../Actions/Actions";






const initialState = {
  isLoading: false,
  myTasks: [],
  error: null,
};

const getAllEmployeeTask = (state = initialState,{type,payload}) => {
  switch (type) {
    case GET_ALL_EMP_TASKS_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case GET_ALL_EMP_TASKS_SUCCESS:
      return { ...state, isLoading: false, myTasks: payload};
    case GET_ALL_EMP_TASKS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default getAllEmployeeTask;
